// Configuração de ambiente
const ENV = process.env.NODE_ENV || 'development'

// Configurações por ambiente
const ENV_CONFIG = {
  development: {
    apiUrl: 'http://localhost:3000/api',
    version: {
      major: 3,
      minor: 3,
      patch: 1,
      build: '2026.02.27',
      releaseDate: '2026-02-27',
      codename: 'Loja Express Manager'
    }
  },
  staging: {
    apiUrl: 'https://staging-api.express.com/api',
    version: {
      major: 3,
      minor: 3,
      patch: 1,
      build: '2026.02.27',
      releaseDate: '2026-02-27',
      codename: 'Express Manager Staging'
    }
  },
  production: {
    apiUrl: 'https://api.express.com/api',
    version: {
      major: 3,
      minor: 3,
      patch: 1,
      build: '2026.02.27',
      releaseDate: '2026-02-27',
      codename: 'Express Manager'
    }
  }
}

// Configuração atual baseada no ambiente
export const CURRENT_ENV = ENV_CONFIG[ENV] || ENV_CONFIG.development

// Função para obter a versão do ambiente atual
export function getEnvironmentVersion() {
  return CURRENT_ENV.version
}

// Função para obter a URL da API do ambiente atual
export function getApiUrl() {
  return CURRENT_ENV.apiUrl
}

// Função para verificar se está em desenvolvimento
export function isDevelopment() {
  return ENV === 'development'
}

// Função para verificar se está em produção
export function isProduction() {
  return ENV === 'production'
}

// Função para verificar se está em staging
export function isStaging() {
  return ENV === 'staging'
}

// Função para obter informações do ambiente
export function getEnvironmentInfo() {
  return {
    environment: ENV,
    apiUrl: getApiUrl(),
    version: getEnvironmentVersion(),
    isDev: isDevelopment(),
    isProd: isProduction(),
    isStaging: isStaging()
  }
}

export default CURRENT_ENV
